import { ComponentsProps } from '@material-ui/core/styles/props';

export const props: ComponentsProps = {};
